export default __webpack_public_path__ + "static/media/Arrow1.d8778796.svg";